import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const KeystoneIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-10 0 210 185"
    {...props}
  >
      <g opacity={0.98}>
          <path
            d="M461.82 215.24h-150a17.17 17.17 0 00-17.12 17.12v40.35h41.61v-6.59a9.26 9.26 0 019.26-9.26h82.53a9.26 9.26 0 019.26 9.26v6.59H479v-40.35a17.18 17.18 0 00-17.18-17.12zM437.33 344.72a9.27 9.27 0 01-9.26 9.26h-82.53a9.27 9.27 0 01-9.26-9.26v-6.59h-41.61v40.34a17.17 17.17 0 0017.12 17.13h150A17.18 17.18 0 00479 378.47v-40.34h-41.67z"
            fill="#ed1944"
            transform="translate(-294.67 -215.24)"
          ></path>
          <path d="M0 69.37H41.62V110.99000000000001H0z" fill="#ed1944"></path>
          <path
            d="M142.66 69.37H184.28V110.99000000000001H142.66z"
            fill="#ed1944"
          ></path>
      </g>
  </SvgIcon>
);

